import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Truck, Clock, CheckCircle2, Lock, PackageCheck, AlertTriangle, Users, MapPin, ShieldCheck, MessageCircle } from "lucide-react";

const PURPLE = "#2B1E4A";
const MAGENTA = "#B5179E";
const GOLD = "#F5B400";

function Card({ label, value, icon: Icon, color }) {
  return (
    <div className="rounded-2xl border border-border bg-white p-4" data-testid={`rota-kpi-${label}`}>
      <div className="flex items-center gap-2">
        <span className="grid h-8 w-8 place-items-center rounded-lg text-white" style={{ background: color }}><Icon size={16} /></span>
        <span className="text-[10px] uppercase tracking-widest text-[#9A8A98]">{label}</span>
      </div>
      <div className="mt-2 font-display text-2xl font-bold" style={{ color: PURPLE }}>{value}</div>
    </div>
  );
}

export default function LogisticaDashboard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [bu, setBu] = useState("");
  useEffect(() => { api.get("/deliveries/dashboard", { params: bu ? { business_unit: bu } : {} }).then(({ data }) => setD(data)).catch(() => setD(null)); }, [bu]);
  return (
    <div className="space-y-5 p-4 lg:p-8" data-testid="rota-dashboard">
      <div className="flex flex-wrap items-center gap-3 rounded-2xl p-5 text-white" style={{ background: `linear-gradient(135deg, ${PURPLE}, ${MAGENTA})` }}>
        <span className="grid h-12 w-12 place-items-center rounded-xl" style={{ background: GOLD }}><Truck size={24} className="text-[#2B1E4A]" /></span>
        <div className="flex-1">
          <div className="text-[11px] font-bold uppercase tracking-[0.25em]" style={{ color: GOLD }}>CRIS ROTA</div>
          <h1 className="font-display text-xl font-bold">Logística Inteligente</h1>
        </div>
        <select value={bu} onChange={(e) => setBu(e.target.value)} data-testid="rota-bu-filter" className="rounded-full bg-white/15 px-3 py-1.5 text-[12px] font-bold text-white outline-none">
          <option value="" className="text-black">Todas as unidades</option>
          <option value="CRIS_LINGERIE" className="text-black">Cris Lingerie</option>
          <option value="ELETROS" className="text-black">Eletros</option>
        </select>
      </div>
      {!d ? <div className="p-8 text-center text-sm text-[#9A8A98]">Carregando...</div> : (
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-3 xl:grid-cols-6">
          <Card label="Total" value={d.total} icon={PackageCheck} color={PURPLE} />
          <Card label="Aguard. assinatura" value={d.waiting_signature} icon={Lock} color="#E11D48" />
          <Card label="Liberadas" value={d.ready} icon={CheckCircle2} color="#059669" />
          <Card label="Em rota" value={d.in_route} icon={Truck} color={GOLD} />
          <Card label="Concluídas" value={d.delivered} icon={CheckCircle2} color="#2563EB" />
          <Card label="Falhas" value={d.failed} icon={AlertTriangle} color="#B45309" />
        </div>
      )}
      <div className="flex gap-2">
        <button onClick={() => nav("/admin/logistica/entregas")} className="rounded-xl px-4 py-2.5 text-sm font-bold text-white" style={{ background: PURPLE }} data-testid="rota-go-deliveries">Ver entregas</button>
        <button onClick={() => nav("/admin/logistica/rotas")} className="rounded-xl px-4 py-2.5 text-sm font-bold text-white" style={{ background: MAGENTA }} data-testid="rota-go-routes">Rotas</button>
        <button onClick={() => nav("/admin/logistica/entregadores")} className="flex items-center gap-1 rounded-xl border border-border px-4 py-2.5 text-sm font-bold text-[#5B2CA0]" data-testid="rota-go-drivers"><Users size={15} /> Entregadores</button>
        <button onClick={() => nav("/admin/logistica/maps")} className="flex items-center gap-1 rounded-xl border border-border px-4 py-2.5 text-sm font-bold text-[#5B2CA0]" data-testid="rota-go-maps"><MapPin size={15} /> Google Maps</button>
        <button onClick={() => nav("/admin/logistica/prova")} className="flex items-center gap-1 rounded-xl border border-border px-4 py-2.5 text-sm font-bold text-[#5B2CA0]" data-testid="rota-go-pod"><ShieldCheck size={15} /> Prova de Entrega</button>
        <button onClick={() => nav("/admin/logistica/whatsapp")} className="flex items-center gap-1 rounded-xl border border-border px-4 py-2.5 text-sm font-bold text-[#5B2CA0]" data-testid="rota-go-wa"><MessageCircle size={15} /> WhatsApp</button>
      </div>
    </div>
  );
}
